const csvTemplate = `cerebro_id,address_type,address_name,address_identification,address_contact_person,address_street,address_street2,address_postal_code,address_phone,address_country_cerebro_id,address_state_cerebro_id,address_city,address_district,address_email,address_mobile,address_notes,store_code,address_id,address_is_premium
,invoice,Top shop,,,,,,,241,1066,Kabupaten Pati,Pati,,,,,,
,delivery,Aneka,,,,,,,,,,,,,,STORE-002,,
,delivery,Superindo,,,,,,,,,,,,,,STORE-003,,
,ktp,,1275872947,,,,,,,,,,,,,,,
,npwp,,583859378,,,,,,,,Kota Jakarta Barat,,,,,,,
,store,Guardian meruya,,,jl meruya,,,,241,1066,Kota Jakarta Barat,Kembangan,,,,STOREABC,,false`;

export default csvTemplate;
